import { createRouter, createWebHashHistory } from 'vue-router';
import type { RouteRecordRaw } from 'vue-router';
import { DEFAULT_PAGE_ID } from '@/constants/catalog';

// 路由
const routes: RouteRecordRaw[] = [
    // 重定向到home
    {
        path: '/',
        redirect: { name: DEFAULT_PAGE_ID }
    },
    // 首页
    {
        path: '/home',
        name: 'page-home',
        component: () => import("@/views/Home/index.vue")
    },
    // 搜索页
    {
        path: '/search',
        name: 'page-search',
        component: () => import("@/views/Search/index.vue")
    },
    // office页
    {
        path: '/office',
        name: 'page-office',
        component: () => import("@/views/Office/index.vue")
    },
    // 激活码购买页
    {
        path: '/activation',
        name: 'page-activation',
        component: () => import("@/views/Activation/index.vue")
    },
    // 安装office页
    {
        path: '/install',
        name: 'page-install',
        component: () => import("@/views/Install/index.vue")
    },
    // 全部ai插件页
    {
        path: '/plugins',
        name: 'page-plugins',
        component: () => import("@/views/Plugins/index.vue")
    },
    // 快捷技巧页
    {
        path: '/tips',
        name: 'page-tips',
        component: () => import("@/views/Tips/index.vue")
    },
    // 全部商品页
    {
        path: '/products',
        name: 'page-products',
        component: () => import("@/views/Products/index.vue")
    },
    // 确认购买页
    {
        path: '/purchase',
        name: 'page-purchase',
        component: () => import("@/views/Purchase/index.vue")
    },
    // AI&智能体页
    {
        path: '/ai-lobster',
        name: 'page-ai-lobster',
        component: () => import("@/views/AiLobster/index.vue")
    },
    // AI&智能体详情页
    {
        path: '/ai-lobster/detail',
        name: 'page-ai-lobster-detail',
        component: () => import("@/views/AiLobster/Detail.vue")
    },
    // 第二步：激活账号绑定
    {
        path: '/step2-activation',
        name: 'page-step2-activation',
        component: () => import("@/views/Step2Activation/index.vue")
    },
    // 第三步：安装并开始使用
    {
        path: '/step3-install',
        name: 'page-step3-install',
        component: () => import("@/views/Step3Install/index.vue")
    },
    // 密钥激活
    {
        path: '/activate-key',
        name: 'page-activate-key',
        component: () => import("@/views/ActivateKey/index.vue")
    },
    // C盘清理
    {
        path: '/disk-clean',
        name: 'page-disk-clean',
        component: () => import("@/views/DiskClean/index.vue")
    },
    // 看图
    {
        path: '/image-viewer',
        name: 'page-image-viewer',
        component: () => import("@/views/ImageViewer/index.vue")
    },
    // 压缩
    {
        path: '/compress',
        name: 'page-compress',
        component: () => import("@/views/Compress/index.vue")
    },
    // PDF 工具
    {
        path: '/pdf-tools',
        name: 'page-pdf-tools',
        component: () => import("@/views/PdfTools/index.vue")
    },
    // Ai 插件广场
    {
        path: '/plugin-plaza',
        name: 'page-plugin-plaza',
        component: () => import("@/views/PluginPlaza/index.vue")
    },
    // 我的订单页
    {
        path: '/orders',
        name: 'page-orders',
        component: () => import("@/views/Orders/index.vue")
    },
    // 已安装插件页
    {
        path: '/plugins-mine',
        name: 'page-plugins-mine',
        component: () => import("@/views/PluginsMine/index.vue")
    },
    // 帮助中心页
    {
        path: '/help',
        name: 'page-help',
        component: () => import("@/views/Help/index.vue")
    },
    // 联系客服页
    {
        path: '/contact',
        name: 'page-contact',
        component: () => import("@/views/Contact/index.vue")
    },
    // 未知路由重定向到home
    {
        path: '/:pathMatch(.*)*',
        redirect: { name: DEFAULT_PAGE_ID }
    },
];

const router = createRouter({
    history: createWebHashHistory(import.meta.env.BASE_URL),
    routes,
});

export default router;
